// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div .ddc-dropdown__menu, div .ddc-ml-dropdown__menu {
    margin-bottom: 0;
    margin-top: 0;
}

div .ddc-dropdown__control, div .ddc-ml-dropdown__control {
    min-height: 36px;
    border-color: rgb(204, 204, 204);
    box-shadow: none;
    width: 100%;
}

div .ddc-dropdown__control:hover, div .ddc-ml-dropdown__control:hover {
    border-color: rgb(204, 204, 204);
}

div .ddc-dropdown__indicator, div .ddc-ml-dropdown__indicator, .ddc-ml-dropdown-arrow-right {
    color: #999;
}

div .ddc-dropdown__indicator, div .ddc-ml-dropdown__indicator {
    padding: 4px;
}

div .ddc-dropdown__indicator:hover, div .ddc-ml-dropdown__indicator:hover {
    color: hsl(0, 0%, 20%);
}

.ddc-ml-dropdown-arrow-right {
    max-height: 14px;
    align-items: center;
    display: flex;
}

div .ddc-dropdown__menu-list, div .ddc-ml-dropdown__menu-list {
    padding: 0;
}

div .ddc-ml-dropdown__menu-list {
    overflow-y: visible;
}

div .ddc-dropdown__input-container {
    margin: 0;
    padding: 0;
}

.ddc-ml-option {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  font-size: inherit;
}

.ddc-ml-option > .ddc-ml-submenu {
  width: 100%;
}

.ddc-ml-option:hover > .ddc-ml-submenu {
  display: block;
}

.ddc-ml-option:hover {
  background-color: #deebff;
}

.ddc-ml-submenu {
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1),0 4px 11px hsla(0, 0%, 0%, 0.1);
  background: white;
  z-index: 1000;
  border-radius: 4px;
}

.ddc-ml-option-is-selected, div .ddc-dropdown__option--is-selected, div .ddc-dropdown__option:active {
    background-color: rgba(222, 235, 255, 0.6);
}

div .ddc-dropdown__option--is-selected {
    color: black;
}

div .ddc-dropdown__option--is-selected:hover {
    background-color: rgba(222, 235, 255, 1)
}

div .ddc-dropdown__multi-value__label {
    white-space: wrap;
}
`, "",{"version":3,"sources":["webpack://./src/lib/styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,0EAA0E;EAC1E,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["div .ddc-dropdown__menu, div .ddc-ml-dropdown__menu {\n    margin-bottom: 0;\n    margin-top: 0;\n}\n\ndiv .ddc-dropdown__control, div .ddc-ml-dropdown__control {\n    min-height: 36px;\n    border-color: rgb(204, 204, 204);\n    box-shadow: none;\n    width: 100%;\n}\n\ndiv .ddc-dropdown__control:hover, div .ddc-ml-dropdown__control:hover {\n    border-color: rgb(204, 204, 204);\n}\n\ndiv .ddc-dropdown__indicator, div .ddc-ml-dropdown__indicator, .ddc-ml-dropdown-arrow-right {\n    color: #999;\n}\n\ndiv .ddc-dropdown__indicator, div .ddc-ml-dropdown__indicator {\n    padding: 4px;\n}\n\ndiv .ddc-dropdown__indicator:hover, div .ddc-ml-dropdown__indicator:hover {\n    color: hsl(0, 0%, 20%);\n}\n\n.ddc-ml-dropdown-arrow-right {\n    max-height: 14px;\n    align-items: center;\n    display: flex;\n}\n\ndiv .ddc-dropdown__menu-list, div .ddc-ml-dropdown__menu-list {\n    padding: 0;\n}\n\ndiv .ddc-ml-dropdown__menu-list {\n    overflow-y: visible;\n}\n\ndiv .ddc-dropdown__input-container {\n    margin: 0;\n    padding: 0;\n}\n\n.ddc-ml-option {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  font-size: inherit;\n}\n\n.ddc-ml-option > .ddc-ml-submenu {\n  width: 100%;\n}\n\n.ddc-ml-option:hover > .ddc-ml-submenu {\n  display: block;\n}\n\n.ddc-ml-option:hover {\n  background-color: #deebff;\n}\n\n.ddc-ml-submenu {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 100%;\n  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1),0 4px 11px hsla(0, 0%, 0%, 0.1);\n  background: white;\n  z-index: 1000;\n  border-radius: 4px;\n}\n\n.ddc-ml-option-is-selected, div .ddc-dropdown__option--is-selected, div .ddc-dropdown__option:active {\n    background-color: rgba(222, 235, 255, 0.6);\n}\n\ndiv .ddc-dropdown__option--is-selected {\n    color: black;\n}\n\ndiv .ddc-dropdown__option--is-selected:hover {\n    background-color: rgba(222, 235, 255, 1)\n}\n\ndiv .ddc-dropdown__multi-value__label {\n    white-space: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
